
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counselling",
      function () {
        return require("private-next-pages/counselling.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/counselling"])
      });
    }
  